import { FetchState } from "@/shared/types";
import { EmployerFeeScheduleState } from "@/admin/types";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";
import { getActiveEmployerFeeSchedules } from "@/shared/api/userService";

export const initialState: EmployerFeeScheduleState = {
  fetchState: FetchState.Uninitialized,
  employerId: 0,
  feeSchedules: []
};

export const useEmployerFeeScheduleStore = defineStore("employerFeeSchedule", {
  state: (): EmployerFeeScheduleState => (_.cloneDeep(initialState)),
  actions: {
    loadFeeSchedules (employerId: number) {
      if (this.employerId === employerId) {
        return;
      }

      this.feeSchedules = [];

      if (employerId <= 0) {
          this.employerId = 0;
          return;
      }

      this.fetchState = FetchState.Loading;

      getActiveEmployerFeeSchedules(employerId)
        .then(response => {
          this.employerId = employerId;
          this.fetchState = FetchState.Loaded;
          this.feeSchedules = response.data.feeSchedules;
        })
        .catch(error => {
          this.feeSchedules = [];
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
